export const INVOICES_SEARCH = 'INVOICES_SEARCH';
export const INVOICE_VIEW = 'INVOICE_VIEW';
export const INVOICE_VIEW_LOADED = 'INVOICE_VIEW_LOADED';
export const INVOICE_APPROVE = 'INVOICE_APPROVE';
export const INVOICE_PAID = 'INVOICE_PAID';
export const INVOICE_CREATE_UPDATE_OK = 'INVOICE_CREATE_UPDATE_OK';
export const INVOICE_UNLOAD = 'INVOICE_UNLOAD';

